import { useEffect, useState, useMemo } from "react";
import { fetchPermissions } from "../../api/accessControl";
import PermissionDetailsDrawer from "./PermissionDetailsDrawer";
import AddPermissionModal from "./AddPermissionModal";

export default function PermissionsTab() {
  const [permissions, setPermissions] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [addOpen, setAddOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const loadPermissions = async () => {
    setLoading(true);
    const data = await fetchPermissions();
    setPermissions(Array.isArray(data) ? data : []);
    setLoading(false);
  };

  useEffect(() => {
    loadPermissions();
  }, []);

  const filteredPermissions = useMemo(() => {
    if (!search.trim()) return permissions;
    const q = search.toLowerCase();
    return permissions.filter(
      (p) =>
        p.code?.toLowerCase().includes(q) ||
        p.description?.toLowerCase().includes(q)
    );
  }, [search, permissions]);

  return (
    <>
      <div className="mb-4 flex justify-between">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white">
          Permissions
        </h2>
      </div>

      {/* SEARCH */}
      <input
        type="text"
        placeholder="Search permissions…"
        className="input mb-6 w-full border border-gray-300 bg-white text-gray-900 placeholder:text-gray-400 md:w-[300px] dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:placeholder:text-gray-500"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? (
        <p className="text-gray-500 dark:text-gray-400">
          Loading permissions…
        </p>
      ) : filteredPermissions.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-400">
          No permissions found.
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {filteredPermissions.map((p) => (
            <div
              key={p.id}
              onClick={() => setSelectedPermission(p)}
              className="dashboard-card cursor-pointer border border-gray-200 bg-white p-6 transition hover:shadow-lg dark:border-gray-800 dark:bg-gray-900 dark:hover:bg-gray-800/70"
            >
              <h3 className="font-bold text-gray-900 dark:text-white">
                {p.code}
              </h3>
              <p className="mt-1 text-gray-500 dark:text-gray-400">
                {p.description}
              </p>
            </div>
          ))}
        </div>
      )}

      <PermissionDetailsDrawer
        permission={selectedPermission}
        onClose={() => setSelectedPermission(null)}
      />

      <AddPermissionModal
        open={addOpen}
        onClose={() => setAddOpen(false)}
        onCreated={loadPermissions}
      />
    </>
  );
}